export default "__VITE_ASSET__BToIX5zV__"